<p-table
  dataKey="name"
  [value]="dataLayerTypes"
  [(selection)]="selectedDataLayerTypes"
  [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 1rem"></th>
      <th>Themenbereich</th>
      <th>Read / Write</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dataLayerType>
    <tr>
      <td>
        <p-tableCheckbox [value]="dataLayerType"></p-tableCheckbox>
      </td>
      <td><i class="fa-regular fa-map"></i></td>
      <td>{{ dataLayerType.name }}</td>
      <td><p-inputSwitch (click)="accessToggle()"></p-inputSwitch></td>
    </tr>
  </ng-template>
</p-table>
